<template>
    <NavbarLogged />
    <ErrorPage v-if="error" :error="error" />
</template>

<script setup lang="ts">
    import {ErrorPage, NavbarLogged} from '#components';
    import {useServerSeoMeta, useTranslation} from '#imports';

    const {t} = useTranslation();

    defineProps<{error: object}>();

    useServerSeoMeta({
        title: t('404.title.page'),
    });
</script>
